
import { BasicController } from "@goodgamestudios/core";
import { MathBase } from "@goodgamestudios/core";

import { TextField } from "@goodgamestudios/createjs-utilities";

import { int } from "@goodgamestudios/math-utilities";

import { getLogger } from "@goodgamestudios/logger";

import { Poker2SoundController } from "../../controller/Poker2SoundController";
import { Poker2SliderEvent } from "../../event/Poker2SliderEvent";
import { SliderHelper } from "./SliderHelper";

import MovieClip = createjs.MovieClip;
import Event = createjs.Event;

import MouseEvent = createjs.MouseEvent;

const logger = getLogger("SliderHelperStepper");

export class SliderHelperStepper extends SliderHelper {
    private _minValue: number = NaN;
    private _maxValue: number = NaN;
    private _numericStepSize: number = NaN;
    private _startValue: number = NaN;
    private _maxSteps: number = NaN;
    private _range: number = NaN;
    private _lastStepAmount: number = NaN;
    private _inputField: TextField;
    private _buttonDown: boolean = false;

    constructor(target: MovieClip) {
        CONSTRUCTOR_HACK;
        super(target);
    }

    /**
     * SliderHelperStepper
     * Extends SliderStepper and is able to increase/decrease the slider's value stepwise with a defined numeric value.
     * The SliderHelperStepper checks if the parameter values makes sense (e.g. min have to be smaller than max etc.) and deactiates the slider
     * compontent otherwise.
     *
     * @param min Mininum numeric value of the slider.
     * @param max Maximum int numeric value of the slider.
     * @param numericStepSize int Numeric Value for the size of one step.
     * @param startValue int Startvalue for the slider's knob.
     * @param inputField Numberic Optional textfield as target input field for the slider. If inputField is given, changes to it will be binded to the sliders view automatically.
     */
    public initSliderStepper(min: number, max: number, numericStepSize: number, startValue: number, inputField: TextField = null): void {
        var errors: boolean = false;

        this._minValue = min;
        this._maxValue = max;
        this._startValue = startValue;
        this._numericStepSize = numericStepSize;

        // sanity check
        if (this._minValue < 0 || isNaN(this._minValue)) {
            logger.debug("initSliderStepper(): minValue: " + this._minValue + ". Set to zero and continue.");
            this._minValue = 0;
        }

        // max < max; try to fix the problem in switching the values!
        if (this._maxValue < this._minValue) {
            logger.debug("initSliderStepper(): maxValue < minValue. _minValue: " + this._minValue + " _maxValue: " + this._maxValue);
            // TODO: Maybe this the reason for Bug Id 605
            // Assumption: the valus are switched
            var nextMax: number = this._minValue;
            this._minValue = this._maxValue;
            this._maxValue = nextMax;
        }

        // sanity check
        if (this._maxValue < 0 || isNaN(this._maxValue)) {
            logger.debug("initSliderStepper(): maxValue: " + this._maxValue);
            errors = true;
        }

        // startValue don't lie between min and max
        if (this._startValue < this._minValue || this._startValue > this._maxValue) {
            logger.debug("initSliderStepper(): startValue don't lie between min and max. startValue: " + this._startValue + ", _minValue " + this._minValue + ", _maxValue: " + this._maxValue);

            // force startValue to be in the middle of min and max
            this._startValue = Math.round((this._minValue + this._maxValue) / 2);
        }

        // sanity check
        if (this._startValue < 0 || isNaN(this._startValue)) {
            logger.debug("initSliderStepper(): startValue: " + this._startValue);
            errors = true;
        }

        // sanity check
        this._range = this._maxValue - this._minValue;
        if (this._range < 0 || isNaN(this._range)) {
            logger.debug("initSliderStepper(): range: " + this._range);
            errors = true;
        }

        // sanity check
        if (this._numericStepSize < 0 || isNaN(this._numericStepSize)) {
            logger.debug("initSliderStepper(): numericStepSize: " + this._numericStepSize);
            errors = true;
        }

        // min = max = start
        if (this._minValue == this._maxValue && this._minValue == this._startValue) {
            logger.debug("initSliderStepper(): _minValue = _maxValue == _startValue.  _minValue: " + this._minValue + ", _maxValue: " + this._maxValue + ", _startValue: " + this._startValue);
            errors = true;
        }

        // stepsize > range
        if (this._numericStepSize >= this._range) {
            logger.debug("initSliderStepper(): _numericStepSize > _range. _numericStepSize: " + this._numericStepSize + ", _range: " + this._range);
            errors = true;
        }

        // check if values are valid
        if (errors) {
            // log all errors
            logger.debug("initSliderStepper(): Invalid values, slider was disabled. _minValue " + this._minValue + ", _maxValue: " + this._maxValue + ", _startValue: " + this._startValue + ", _range: " + this._range + ", numericStepSize: " + this._numericStepSize);

            // disable slider
            this.enabled = false;

            // reset
            this.reset();

            // don't contiue with invalid values
            return;
        }

        //			trace("VALUES _minValue " + _minValue + ", _maxValue: " + _maxValue + ", _startValue: " + _startValue + ", _range: " + _range + ", numericStepSize: " + _numericStepSize);

        // caculate stepsize in percent
        this.StepSize = (this._numericStepSize / this._range) * 100;

        // calculate max steps
        this._maxSteps = Math.ceil(this._range / this._numericStepSize);

        // reset _lastStepAmount
        this._lastStepAmount = -1;

        // enable slider
        this.enabled = true;

        // init input field
        this.initInputField(inputField);

        // init slider
        this.initSlider(this._minValue, this._maxValue, this._startValue);
    }

    protected initInputField(inputField: TextField): void {
        if (!inputField) {
            return;
        }

        this._inputField = inputField;
        this._inputField.addEventListener(Event.CHANGE, this.bindFunction(this.onInputFieldChange), false, 0, true);
        this._inputField.restrict = "0-9";
    }

    public set enabled(value: boolean) {
        Object.getOwnPropertyDescriptor(SliderHelper.prototype, "enabled").set.call(this, value);

        if (!this._enabled) {
            if (this._inputField) {
                this._inputField.stage.focus = null;
            }
        }
    }

    protected onMouseWheel(event: MouseEvent): void {
        if (this.tutorialController.isActive)
            return;

        if (event.delta > 0) {
            this.stepUp();
        }
        else if (event.delta < 0) {
            this.stepDown();
        }
    }

    protected onInputFieldChange(event: Event): void {
        this.checkInputtedValue();
    }

    protected checkInputtedValue(): void {
        var inputtedValue: number = parseFloat(this._inputField.text);

        if (inputtedValue < this._minValue) {
            inputtedValue = this._minValue;
        }
        if (inputtedValue > this._maxValue) {
            inputtedValue = this._maxValue;
        }

        // calculate percentage
        this.currentPos = ((inputtedValue - this._minValue) / this._range) * 100;

        // update view
        this.updateSliderButton();

        // notify clients
        var e: Poker2SliderEvent = new Poker2SliderEvent("onSliding", this.currentPos, false);
        e.onInputFieldChanged = true;
        this.sliderMC.dispatchEvent(e);

        // enable stepping
        this._lastStepAmount = this.getStepAmount();
    }

    private reset(): void {
        this.valueInPercent = 0;
    }

    public initSlider(min: number, max: number, startValue: number): void {
        startValue = int(MathBase.max(this._minValue, MathBase.min(this._maxSteps, this._startValue)));

        var startPercent: number = (this._startValue - this._minValue) / this._range;

        // set start position of the knob
        this.currentPos = this.findStartPos(startPercent);

        this.updateSliderButton();
    }

    public set valueInPercent(value: number) {
        this.currentPos = value;
        this.updateSliderButton();
    }

    private findStartPos(p: number): number {
        var stepAmount: number = (p * 100) / this.StepSize;
        this._lastStepAmount = Math.round(stepAmount);

        return stepAmount * this.StepSize;
    }

    protected onSliding(event: MouseEvent): void {
        super.onSliding(event);
        this._lastStepAmount = this.getStepAmount();
    }

    private getStepAmount(): number {
        var stepAmount: number = this.currentPos / this.StepSize;
        stepAmount = (stepAmount < 0) ? 0 : stepAmount;
        stepAmount = (stepAmount > this._maxSteps) ? this._maxSteps : stepAmount;
        return stepAmount;
    }

    protected onClickButtonUp(event: MouseEvent): void {
        this._buttonDown = !!(event.buttonDown);
        this.stepUp();
    }

    protected stepUp(): void {
        if (!this.buttonUp.enabled)
            return;

        BasicController.getInstance().soundController.playSoundEffectByName(Poker2SoundController.SND_CLICK);

        var stepAmount: number = this.currentPos / this.StepSize;
        stepAmount = Math.ceil(stepAmount);

        // check if stepAmount has changed, if not increase it
        if (this._lastStepAmount == stepAmount) {
            stepAmount++;
        }
        stepAmount = (stepAmount > this._maxSteps) ? this._maxSteps : stepAmount;
        this._lastStepAmount = stepAmount;

        this.currentPos = stepAmount * this.StepSize;
        // don't allow values over 100%
        this.currentPos = (this.currentPos > 100) ? 100 : this.currentPos;

        this.updateSliderButton();
        this.sliderMC.dispatchEvent(new Poker2SliderEvent("slideUp", this.currentPos, this._buttonDown, this.getNumericValue(this.currentPos)));
    }

    private getNumericValue(p: number): number {
        return Math.round(this._minValue + (this._range * p) / 100);
    }

    protected onClickButtonDown(event: MouseEvent): void {
        this._buttonDown = !!(event.buttonDown);
        this.stepDown();
    }

    protected stepDown(): void {
        if (!this.buttonDown.enabled)
            return;

        BasicController.getInstance().soundController.playSoundEffectByName(Poker2SoundController.SND_CLICK);

        var stepAmount: number = this.currentPos / this.StepSize;
        stepAmount = Math.floor(stepAmount);

        // check if stepAmount has changed, if not increase it
        if (this._lastStepAmount == stepAmount) {
            stepAmount--;
        }
        stepAmount = (stepAmount < 0) ? 0 : stepAmount;
        this._lastStepAmount = stepAmount;

        this.currentPos = stepAmount * this.StepSize;
        // don't allow values below 0%
        this.currentPos = (this.currentPos < 0) ? 0 : this.currentPos;

        this.updateSliderButton();
        this.sliderMC.dispatchEvent(new Poker2SliderEvent("slideDown", this.currentPos, this._buttonDown, this.getNumericValue(this.currentPos)));
    }

    public destroy(): void {
        super.destroy();

        if (this._inputField) {
            this._inputField.removeEventListener(Event.CHANGE, this.bindFunction(this.onInputFieldChange));
        }
    }

    protected get tutorialController(): Poker2TutorialController {
        return Poker2TutorialController.getInstance();
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a setter is defined, the getter must be defined as well.
    **/
    public get enabled()/*:Boolean*/ {
        return Object.getOwnPropertyDescriptor(SliderHelper.prototype, "enabled").get.call(this);
    }
}

import { Poker2TutorialController } from "../../controller/Poker2TutorialController";
